import React from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
export function SlideMarket() {
  return <Slide data-id="element-142">
      <SlideHeader data-id="element-143">Market</SlideHeader>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-144">
        <div className="lg:col-span-7" data-id="element-145">
          <motion.h2 variants={itemVariants} className="text-5xl md:text-7xl lg:text-[100px] font-serif leading-[1.05] tracking-tight mb-6" data-id="element-146">
            $14B
          </motion.h2>
          <motion.p variants={itemVariants} className="text-2xl md:text-3xl text-gray-400 font-light mb-12" data-id="element-147">
            AI Dev Tools & DevEx Market by 2028
          </motion.p>

          <motion.div variants={itemVariants} className="space-y-6 max-w-2xl" data-id="element-148">
            <p className="text-lg leading-relaxed" data-id="element-149">
              The market is converging. Standalone DevEx tools (measuring
              humans) and AI Observability tools (measuring models) are merging
              into{' '}
              <span className="font-bold text-white" data-id="element-150">
                AI Engineering Intelligence
              </span>
              .
            </p>
          </motion.div>
        </div>

        <motion.div variants={itemVariants} className="lg:col-span-4 lg:col-start-9" data-id="element-151">
          <h3 className="text-sm text-gray-400 uppercase tracking-widest mb-8" data-id="element-152">
            Competitive Landscape
          </h3>

          <div className="space-y-8" data-id="element-153">
            <div className="border-l border-gray-800 pl-6" data-id="element-154">
              <div className="text-white font-medium mb-1" data-id="element-155">
                Legacy DevEx (DX, Jellyfish, LinearB)
              </div>
              <div className="text-sm text-gray-500" data-id="element-156">
                Built for human workflows. Cannot measure agent autonomy or
                token ROI.
              </div>
            </div>

            <div className="border-l border-gray-800 pl-6" data-id="element-157">
              <div className="text-white font-medium mb-1" data-id="element-158">
                Internal Build (Cortex, Backstage)
              </div>
              <div className="text-sm text-gray-500" data-id="element-159">
                Service catalogs, not intelligence layers. Requires massive
                internal maintenance.
              </div>
            </div>

            <div className="border-l-2 border-white pl-6" data-id="element-160">
              <div className="text-white font-bold mb-1" data-id="element-161">Waydev</div>
              <div className="text-sm text-gray-300" data-id="element-162">
                The only platform built natively to orchestrate and measure both
                human and AI engineering output.
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </Slide>;
}